import './App.css';
import Navbar from './Components/Navbar'
import Textarea from './Components/Textarea'
import Footer from './Components/Footer'

function App() {

  return (
    <div className='App'>
    <Navbar />
    <Textarea />
    <Footer />
    </div>    
  );
}

export default App;
